/**
 * Utils and constants for the Create User form.
 * No React dependencies.
 */

export const ROLE_OPTIONS = [
  { value: '', label: '— Select role —' },
  { value: 'admin', label: 'Admin' },
  { value: 'editor', label: 'Editor' },
  { value: 'viewer', label: 'Viewer' },
  { value: 'contributor', label: 'Contributor' }
];

export const emptyFormData = () => ({
  email: '',
  password: '',
  confirmPassword: '',
  first_name: '',
  last_name: '',
  role: ''
});
